/** Mismo texto por defecto que backend `defaultTicketCloseMessage.ts` (setting `ticketCloseMessageText`). */
export const DEFAULT_TICKET_CLOSE_MESSAGE =
  "💬⚙️ *Ticket de Atención:* {nroticket} 😀 ya fue cerrado. Si necesitas algo más en los próximos {minutos} minutos, te seguimos atendiendo; después te atenderá nuestro asistente 🤖.";

/** Mismo texto por defecto que backend `DEFAULT_REOPEN_GRACE_MESSAGE` (setting `reopenGraceMessageText`). */
export const DEFAULT_REOPEN_GRACE_MESSAGE =
  "👋 Recibimos tu mensaje. Un agente de *{departamento}* te atenderá en breve; si nadie te responde en *{minutos} minutos*, te atenderá nuestro asistente 🤖.";
